import { render, staticRenderFns } from "./SalaryGroupView.vue?vue&type=template&id=603facb4&"
import script from "./SalaryGroupView.vue?vue&type=script&lang=js&"
export * from "./SalaryGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports